/**
 * The 1–10 speed setting turned into motion. Both are relative to the screen's own size, so the
 * same setting looks the same on an HD and a 4K screen.
 */

/**
 * Vertical list: the share of the visible height that passes per second. 5 gives 0.03 — the old
 * screen's fixed `SCROLL_SPEED_MULTIPLIER`, so the default looks like the old screen.
 */
export function listScrollFraction(speed: number): number {
  return 0.006 * clampSpeed(speed);
}

/** Horizontal ad band: the share of the band's width that passes per second. 5 gives 6 %. */
export function adScrollFraction(speed: number): number {
  return 0.012 * clampSpeed(speed);
}

/**
 * Paged ad band: seconds each set of ads stays on screen. 5 gives 10 s; 1 is 30 s, 10 is 5 s.
 */
export function adPageSeconds(speed: number): number {
  return Math.min(30, Math.max(5, Math.round(50 / clampSpeed(speed))));
}

function clampSpeed(speed: number): number {
  return Math.min(10, Math.max(1, speed || 5));
}
